import { useEffect, useState } from 'react';
import {
    Typography,
    Grid,
    Button,
    Stack,
    Snackbar,
    Alert
} from '@mui/material';
import { Input } from '../../components/input';
import { Breadcrumb } from 'components';
import { internalUserSearch, adminRoles, updateUserRoleApi } from 'services';
import { InternalUserGrid } from './InternalUserGrid';
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import ContentPasteSearchOutlinedIcon from '@mui/icons-material/ContentPasteSearchOutlined';

let clearStatus: any = false;
export const InternalUserManagement = () => {
    const [emailValue, setEmailValue] = useState('');
    const [enteredName, setEnteredName] = useState('');
    const [successNotification, setSuccessNotification] = useState(false);
    const [roles, setRoles] = useState([]);
    const [paginationModel, setPaginationModel] = useState({
        page: 1,
        pageSize: 10,
        total: 0,
        data: [],
        isLoading: false
    });
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const jwt: any = localStorage.getItem('token');
    const labUserCheck: any = jwt ? JSON.parse(atob(jwt.split('.')[1])) : null;

    const handleClear = () => {
        clearStatus = true;
        setEnteredName('');
        setEmailValue('');
        pageInitialLoad();
    }

    useEffect(() => {
        if (paginationModel.page) {
            pageInitialLoad();
        }
    }, [paginationModel.page])

    const submitForm = (e: any) => {
        e.preventDefault();
        e.stopPropagation();
        clearStatus = false;
        pageInitialLoad();
    }

    const pageInitialLoad = () => {
        let name = clearStatus ? '' : enteredName;
        let email = clearStatus ? '' : emailValue;
        setPaginationModel(old => ({ ...old, isLoading: true }));
        internalUserSearch(paginationModel.page, name, email).then((res: any) => {
            if (res.status === 200) {
                if (res.data.users.length > 0) {
                    setPaginationModel(old => ({ ...old, isLoading: false, data: res.data.users, total: res.data.usersCount }))
                } else {
                    setPaginationModel(old => ({ ...old, isLoading: false, data: [], total: 0 }));
                }
            } else {
                setError(true);
                setErrorMessage(res.data);
            }
        });
    }

    useEffect(() => {
        adminRoles().then((res: any) => {
            setRoles(res?.data);
        })
    }, [])

    const manageInternalUser = () => {
        return <Grid container spacing={2} mt={1}>
            <Grid item xs={12} sm={12} md={12}>
                <InternalUserGrid
                    paginationModel={paginationModel}
                    labUserCheck={labUserCheck}
                    setPaginationModel={setPaginationModel}
                    roles={roles}
                    handleSave={handleSave}
                />
            </Grid>
        </Grid>
    }

    const handleSave = (items: any) => {
        let obj: any = {
            'userID': items?.id,
            'userRoles': items?.internalUserRoles
        }
        updateUserRoleApi(obj).then((res: any) => {
            if (res.status === 200) {
                setSuccessNotification(true);
            } else {
                setError(true);
                setErrorMessage(res.data);
                setSuccessNotification(false);
            }
        });
    }

    let intenalUserCheck = (labUserCheck?.Permission?.includes('StandardQuotes') || labUserCheck?.Permission === 'StandardQuotes') ? '/home/viewQuote' : '/home/admin';
    let pathChange = (labUserCheck && (labUserCheck?.UserType === 'Internal')) ? intenalUserCheck : '/home';
    let nav: any = [{ name: 'Home', path: pathChange }, { name: 'Admin', path: '/home/admin' }, { name: 'Internal User Management', path: '/home/internal' }];

    return (
        <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '16px 0', cursor: 'pointer' }}>
                <Breadcrumb navList={nav} />
            </div>
            <Typography variant="h6" gutterBottom align='left' mb={4}>
                Internal User Management
            </Typography>
            <form onSubmit={(e: any) => submitForm(e)} style={{ width: '100%' }}>
                <Grid container spacing={2} style={{ backgroundColor: '#f5f5f5', marginLeft: '0px', padding: '16px', borderRadius: '6px', width: '100%' }}>
                    <Grid item xs={4} sm={6} md={4} style={{ padding: '0px 8px' }}>
                        <Input
                            label="Name"
                            size="small"
                            sx={{
                                '.MuiInputLabel-root': {
                                    fontSize: '12px'
                                },
                                width: '100%'
                            }}
                            value={enteredName}
                            onChange={(event: any) => setEnteredName(event.target.value)}
                        />
                    </Grid>
                    <Grid item xs={4} sm={6} md={4} style={{ padding: '0px 8px' }}>
                        <Input
                            label="Email"
                            size="small"
                            sx={{
                                '.MuiInputLabel-root': {
                                    fontSize: '12px'
                                },
                                width: '100%'
                            }}
                            value={emailValue}
                            onChange={(event: any) => setEmailValue(event.target.value)}
                        />
                    </Grid>
                    <Grid item xs={8} sm={6} md={3} style={{ padding: '0px 8px' }} sx={{ mt: { xs: 2, sm: 1, md: 0 } }}>
                        <Button
                            variant="contained"
                            color="primary"
                            startIcon={<ContentPasteSearchOutlinedIcon />}
                            type="submit"
                        >
                            Search
                        </Button>
                        <Button
                            variant="outlined"
                            color="primary"
                            startIcon={<ClearOutlinedIcon />}
                            onClick={handleClear}
                            sx={{ marginLeft: '8px' }}
                        >
                            Clear All
                        </Button>
                    </Grid>
                </Grid>
            </form>
            <div style={{ width: "100%" }}>
                {manageInternalUser()}
            </div>
            <Stack sx={{ width: '100%', marginTop: 2 }} spacing={2}>
                <Snackbar open={successNotification} autoHideDuration={6000} onClose={() => setSuccessNotification(false)}>
                    <Alert severity="success" onClose={() => setSuccessNotification(false)}>Updated Successfully !</Alert>
                </Snackbar>
                <Snackbar open={error} autoHideDuration={6000} onClose={() => setError(false)}>
                    <Alert severity="error" onClose={() => setError(false)}>{errorMessage}</Alert>
                </Snackbar>
            </Stack>
        </div >
    );
}
